import styles from './LoadingSpinner.module.css';

interface LoadingSpinnerProps {
    size?: 'sm' | 'lg';
    fullPage?: boolean;
}

export function LoadingSpinner({ size = 'sm', fullPage = false }: LoadingSpinnerProps) {
    // Combine classes: basic spinner + optional large size
    const spinnerClass = `${styles.spinner} ${size === 'lg' ? styles.spinnerLg : ''}`;

    return (
        <div className={fullPage ? styles.loaderContainer : styles.searchLoader}>
            <div className={spinnerClass} />
        </div>
    );
}